export const ITEM_TYPES = {
  PSORTHOTILE: 'PSOrthoTile',
  REORTHOTILE: 'REOrthoTile',
  RESCENE: 'REScene',
  SENTINEL2L1C: 'Sentinel2L1C',
  LANDSAT8: 'Landsat8L1G',
  SKYSATCOLLECT: 'SkySatCollect',
  SKYSATSCENE: 'SkySatScene',
  SENTINEL1: 'Sentinel1',
  PSSCENE: 'PSScene',
};

/**
 * A lookup of known good item types.  These must correspond to items in the
 * API that have a visual representation.  Before adding to this lookup, we
 * need to confirm that tiles, thumbnails, and orders all work.  In addition,
 * these item types should conform to the common set of metadata fields.
 * The values in this lookup determine whether an item type is selected by
 * default (e.g. `REOrthoTile: true` means RapidEye is selected by default
 * and `PSScene3Band: false` means PS 3-band is available but not selected
 * by default).
 */
export const GOOD_ITEM_TYPES = {
  [ITEM_TYPES.PSSCENE]: true,
  [ITEM_TYPES.REORTHOTILE]: false,
  [ITEM_TYPES.RESCENE]: false,
  [ITEM_TYPES.SENTINEL2L1C]: false,
  [ITEM_TYPES.LANDSAT8]: false,
  [ITEM_TYPES.SKYSATCOLLECT]: true,
  [ITEM_TYPES.SKYSATSCENE]: false,
};

export const SENSOR_GROUPS = {
  HIGH: {
    label: 'High Resolution (< 1m)',
    types: [ITEM_TYPES.SKYSATSCENE, ITEM_TYPES.SKYSATCOLLECT],
  },
  MEDIUM: {
    label: 'Medium Resolution (3-7m)',
    types: [ITEM_TYPES.PSSCENE, ITEM_TYPES.RESCENE, ITEM_TYPES.REORTHOTILE],
  },
  NONPLANET: {
    label: 'Non-Planet Datasets (> 10m)',
    types: [ITEM_TYPES.SENTINEL2L1C, ITEM_TYPES.LANDSAT8],
  },
};

/**
 * PlanetScope Item Types
 */
export const PS_ITEM_TYPES = [ITEM_TYPES.PSSCENE, ITEM_TYPES.PSORTHOTILE];
